var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-badge",
    { attrs: { variant: _vm.badgeVariant, pill: _vm.badgePill } },
    [_vm._v(_vm._s(_vm.badgeText))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }